module.exports = __webpack_public_path__ + "static/media/DanHat.a8d07042.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/DanHat.jpg
// module id = 1481
// module chunks = 0